import React from "react";
import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";
import { MdSearchOff, MdStorefront, MdSearch } from "react-icons/md";

import styles from "./CategoryDetails.module.scss";
import { useCategoryDetails } from "./useCategoryDetails";
import { useSearch } from "../../../common/components/search/useSearch";
import { Search } from "../../../common/components/search/Search";
import { PageHeader } from "../../../common/components/pageHeader/PageHeader";
import { EmptyState } from "../../../common/components/emptyState/EmptyState";
import { ItemCard } from "../../../common/components/itemCard/ItemCard";
import { categoryRoute } from "../../../common/utils/constants";

export const CategoryDetails: React.FC = () => {
  const { query, setQuery, clearSearch, isDebouncing } = useSearch(400, true);

  const {
    category,
    items,
    total,
    ready,
    isFetching,
    isFetchingMore,
    lastItemRef,
  } = useCategoryDetails();

  if (!ready) return null;

  if (!category) {
    return (
      <div className={styles.Page}>
        <EmptyState
          icon={MdSearchOff}
          title="Категория не найдена"
          description="Возможно, она была удалена."
        />
      </div>
    );
  }

  const isBusy = isFetching || isDebouncing;

  return (
    <div className={styles.Page}>
      <Helmet>
        <title>{`${category.name} — ЛОГМОЛЛ`}</title>
        <meta
          name="description"
          content={category.description || category.name}
        />
      </Helmet>

      <PageHeader title={category.name} subtitle={`${total} товаров`} />

      {/* Дочерние категории */}
      {!query && category.children && category.children.length > 0 && (
        <div className={styles.SubCategoriesList}>
          {category.children.map((child) => (
            <Link
              key={child.id}
              to={categoryRoute(child.id!)}
              className={styles.SubCategoryCard}
            >
              {child.name}
            </Link>
          ))}
        </div>
      )}

      <div className={styles.SearchWrap}>
        <Search
          value={query}
          onChange={setQuery}
          clear={clearSearch}
          placeHolder={`Поиск в категории «${category.name}»...`}
        />
      </div>

      {items.length === 0 && !isBusy ? (
        query.trim() ? (
          <EmptyState
            icon={MdSearchOff}
            title="Ничего не найдено"
            description={`По запросу «${query}» нет товаров.`}
          />
        ) : (
          <EmptyState
            icon={MdSearch}
            title="Введите запрос"
            description="Начните вводить название товара, чтобы найти нужное."
          />
        )
      ) : items.length === 0 && isBusy ? (
        <div style={{ minHeight: 400 }} />
      ) : (
        <>
          <div className={styles.Grid}>
            {items.map((item, index) => (
              <ItemCard
                key={item.id}
                item={item}
                lastItemRef={
                  index === items.length - 1 ? lastItemRef : undefined
                }
              />
            ))}
          </div>

          {isFetchingMore && (
            <div
              style={{
                textAlign: "center",
                padding: "20px",
                color: "var(--text-secondary)",
              }}
            >
              Загрузка...
            </div>
          )}
        </>
      )}
    </div>
  );
};
